import { render } from "./navbarVertical.vue?vue&type=template&id=36b43189"
import script from "./navbarVertical.vue?vue&type=script&lang=js"
export * from "./navbarVertical.vue?vue&type=script&lang=js"

import "./navbarVertical.vue?vue&type=style&index=0&id=36b43189&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__